import React from 'react'
import { Button, Form, ModalBody } from 'reactstrap';

export const AuthorizedSpecialDiscount = (props) => {

    const {
        toggle, loading, saveAuthorized, idSpecialDiscount,
    } = props;

    return (
        <Form onSubmit={saveAuthorized}>
            <div className='text-center'>
                <div className="auth-icon">
                    <i className="fa fa-exclamation"></i>
                </div>

                <p className="auth-subtitle">CONFIRMACIÓN DE ACCIÓN</p>

                <h5 className="auth-title">
                    ¿Autorizar el descuento especial?
                </h5>

                <div className="auth-code-box">
                    <span className="auth-code-label">CÓDIGO DE REFERENCIA</span>
                    <strong>{`COD-00${idSpecialDiscount}`}</strong>
                </div>

                <p className="auth-description">
                    Estás a punto de validar el descuento. Esta acción quedará
                    registrada en el historial del sistema.
                </p>

                {/* BOTONES */}
                <div className="auth-actions">
                    <Button
                        type="button"
                        className="btn-cancel"
                        color='danger'
                        onClick={toggle}
                    >
                        Cancelar
                    </Button>

                    <Button
                        type="submit"
                        className={`btn-confirm ${loading ? "disabled" : ""}`}
                    >
                        <i className="fa fa-check mr-1"></i>
                        Sí, autorizar
                    </Button>
                </div>

            </div>


        </Form>
    )
}